import React from 'react';
import cx from 'classnames';
import { DEFAULT_COLUMNS } from 'constants/comparisonTableData';
import { Table, useWindowSize } from 'library';

import './BaseTable.scss';

const mapDataForMobile = (data, mobileColumns) => {
  // Remove empty row for desktop table
  const rows = DEFAULT_COLUMNS.slice(1, DEFAULT_COLUMNS.length);
  const columns = mobileColumns;

  return rows.map((row) => {
    const cellData = { id: row.key, row: row.label };
    columns.forEach((col) => {
      const cell = data.find((item) => {
        return item.row === col.label;
      });

      if (cell) {
        cellData[col.key] = cell[row.key];
      }
    });
    return cellData;
  });
};

const BaseTable = ({ data, mobileColumns, logoColumnBackground = 'grey' }) => {
  const { isScreenSize } = useWindowSize();

  const columns = DEFAULT_COLUMNS;

  return (
    <Table
      columns={isScreenSize('sm') ? mobileColumns : columns}
      data={isScreenSize('sm') ? mapDataForMobile(data, mobileColumns) : data}
      className={cx('ComparisonTable', {
        hasWhiteLogoColBg: logoColumnBackground === 'white',
        hasGreyLogoColBg: logoColumnBackground === 'grey',
      })}
    />
  );
};

export default BaseTable;
